import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOpessoaNaoHabilitada = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="EXERCÍCIO ILEGAL" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Nome" nome="topessoanaohabilitada" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="43vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="RG" nome="torgilegal" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="15vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="CPF" nome="tocpfilegal" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="15vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Outros Dados" nome="todados" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="79vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Descrição da Situação Encontrada" nome="todescricao" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="79vw" widthMobile="80vw" marginR="3vw" />
                    </div>

                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                    {/* <Select label="Conformidade com a Resolução COFFITO Nº 517/2020" nome="resolucao517" modulo={modulo} index={n}
                           widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                            array={["Sim", "Não", "Não se Aplica"]} />
                    <Select label="Utilização de Epi por Parte do Profissional em Conformidade com a Nota Técnica ANVISA 04/2020 e Nota Técnica ANVISA 07/2020" nome="resolucao517" modulo={modulo} index={n}
                           widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                            array={["Sim", "Não", "Não se Aplica"]} /> */}
                    <Select label="Delegação de função do profissional terapeuta à pessoa não habilitada para exercer a Terapia Ocupacional (Lei Federal 6.316/1975 e Resolução COFITTO 425/13)" nome="delegTO" modulo={modulo} index={n}
                           widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                            array={["Sim", "Não"]} />
                        <Input label="Quantos Profissionais Delegando Função" nome="tolegalidade" modulo={modulo} index={n}
                           widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        {RenderQtdlegalidade()}
                    </div>
                </Caixa >

            )
            function RenderQtdlegalidade() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["tolegalidade"]
                if (array[modulo][n]["tolegalidade"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                                <Input label="Nome" nome="tonomelegalidade" modulo={modulo} index={n} subModulo="tonomelegalidade" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="60vw" widthMobile="80vw" marginR="3vw" />
                               
                                <Input label="Crefito" nome="tocrefitolegalidade" modulo={modulo} index={n} subModulo="tocrefitolegalidade" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw" />
                            </div>
                        )
                    }
                }
                return campos
            }
        }
        return partes
    }
}

export default TOpessoaNaoHabilitada